import React from "react";
import { Mercator } from "@visx/geo";

import { FeatureShape } from "../WorldMap.types";
import { getFeatures, convertCodeThreeToTwo } from "../WorldMap.helpers";
import { useStyles } from "../WorldMap.styles";
import topology from "../topo/world-topo.json";
import { WorldMapContentProps } from "./WorldMapContent.types";

function WorldMapContent<T>(props: WorldMapContentProps<T>) {
  const {
    getCountryFill,
    getCountryByCode,
    onCountryMouseOver,
    onCountryMouseOut,
    scale,
    translate,
  } = props;

  const classes = useStyles();

  const features = React.useMemo(() => {
    return getFeatures(topology);
  }, []);

  return (
    <Mercator<FeatureShape> data={features} scale={scale} translate={translate}>
      {(mercator) => (
        <g>
          {mercator.features.map(({ feature, path, centroid }, i) => {
            const countryCode = convertCodeThreeToTwo(feature.id);
            const country = getCountryByCode(countryCode);
            const fill = getCountryFill(country);
            return (
              <g key={`map-feature-${i}`}>
                <path
                  className={classes.path}
                  fill={fill}
                  d={path || ""}
                  stroke="white"
                  strokeWidth={1}
                  onMouseOver={(event) =>
                    onCountryMouseOver(event, feature, country)
                  }
                  onMouseOut={onCountryMouseOut}
                />
                <circle cx={centroid[0]} cy={centroid[1]} r={1} opacity="0" />
              </g>
            );
          })}
        </g>
      )}
    </Mercator>
  );
}

export default React.memo(WorldMapContent) as typeof WorldMapContent;
